"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appRoles = exports.loginRequest = exports.protectedResources = exports.graphMethod = exports.graphConfig = exports.msalConfig = exports.apiConfig = void 0;
var msal_browser_1 = require("@azure/msal-browser");
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
exports.apiConfig = {
    //basePath: "https://webnova.azurewebsites.net",
    //basePath: "https://nova.nbit.technology",
    //basePath: "https://nova.z01.azurefd.net",
    ////////////////////////////////////////////////
    //basePath: "https://devapp-webnova.nbit.com.my",
    basePath: "https://nova.nbit.com.my",
    //basePath: "https://localhost:44301"
};
exports.msalConfig = {
    auth: {
        clientId: "0a5e6908-ddd8-4dba-b28f-64e22b6f8de8",
        authority: "https://login.microsoftonline.com/b41ce055-c772-45af-81af-6bebaf877e4a",
        redirectUri: exports.apiConfig.basePath,
        //postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        //navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: function (level, message, containsPii) {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case msal_browser_1.LogLevel.Error:
                        console.error(message);
                        return;
                    case msal_browser_1.LogLevel.Info:
                        console.info(message);
                        return;
                    case msal_browser_1.LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case msal_browser_1.LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
exports.graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/beta/me",
    //graphUsersEndpoint: "https://graph.microsoft.com/beta/users",
    //graphMailEndpoint: "https://graph.microsoft.com/beta/me/messages"
};
exports.graphMethod = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
};
exports.protectedResources = {
    apiResource: {
        //customerListEndpoint: "http://localhost:44301/api/customers",
        //subscriptionListEndpoint: "http://localhost:44301/api/subscriptions",
        scopes: ["User.Read"],
    },
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
exports.loginRequest = {
    scopes: __spreadArray([], exports.protectedResources.apiResource.scopes, true)
};
exports.appRoles = {
    SuperAdmin: "NOVA.SuperAdmin",
    CompanyAdmin: "NOVA.CompanyAdmin",
    CompanyStaff: "NOVA.CompanyStaff"
};
//# sourceMappingURL=authConfig.js.map